import './WifiOnboarding.css';

import React, { useEffect } from 'react';
import { WifiOnboardingHeader } from './WifiOnboardingHeader';
import { WifiOnboardingContent } from './WifiOnboardingContent';
import { useWifiNetworks } from '@src/contexts';

interface WifiProps {
  onComplete: () => void
}

export const WifiOnboarding = ({ onComplete }: WifiProps): JSX.Element => {
  const { requestNetworkPolling } = useWifiNetworks();

  useEffect(() => {
    return requestNetworkPolling();
  }, []);

  return (
    <div id="wifi_onboarding">
      <div id="wifi_onboarding_header_container">
        <WifiOnboardingHeader />
      </div>
      <div id="wifi_onboarding_content_container">
        <WifiOnboardingContent
          onSkipWifiSelection={onComplete}
          onWifiOnboardingComplete={onComplete}
        />
      </div>
    </div>
  );
};
